import { render, staticRenderFns } from "./DemoSwat.vue?vue&type=template&id=23b40694&"
import script from "./DemoSwat.vue?vue&type=script&lang=js&"
export * from "./DemoSwat.vue?vue&type=script&lang=js&"
import style0 from "./DemoSwat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports